<template>
<div id="demo-basic-card">
  <div id="dashboard-analytics">
      <div class="vx-row ml-0">
        <div class="vx-card">
          <div class="vx-col p-8 vx-card">
            <div class="vx-row mb-4 ml-4"><span class="title_card">{{$t('generalSettingMenu.btn1')}}</span></div>
            <div class="mt-2 vx-col">
              <div class="vx-row">
                <div class="vx-col md:w-1/2 w-full">
                  <label class="font-semibold">{{$t('adminUser.organizationName')}}</label>
                  <vs-input class="w-full"
                    v-validate="'required|min:3'"
                    data-vv-validate-on="blur"
                    type="text"
                    name="organizationName"
                    v-model="user.organizationName"
                    autocomplete="off"
                    />
                  <span class="text-danger text-sm">{{
                      errors.first("organizationName")
                    }}</span>
                </div>
                <div class="vx-col md:w-1/2 w-full">
                  <label class="font-semibold">{{$t('adminUser.job')}}</label>
                  <v-select class="w-full"
                            v-model="jobSelect"
                            v-validate="'required'"
                            name="job"
                            :options="optionalJobs"
                  >
                  </v-select>
                  <span class="text-danger text-sm">{{
                      errors.first("job")
                    }}</span>
                </div>
              </div>
              <hr class="mt-8 mb-6 opacity-25">
              <div class="vx-row mt-2">
                <div class="vx-col md:w-1/2 w-full">
                  <div style="display: flex;justify-content: space-between">
                    <label class="font-semibold">Email</label>
                    <label class="opacity-75" style="font-size: 12px;;">{{$t('generalSettingMenu.textLabel')}}</label>
                  </div>
                  <vs-input class="w-full"
                    v-validate="'required|email'"
                    data-vv-validate-on="blur"
                    type="email"
                    name="email"
                    v-model="user.email"
                    autocomplete="off"
                    disabled="true"
                    />
                  <span class="text-danger text-sm">{{
                      errors.first("email")
                    }}</span>
                </div>
                <div class="vx-col md:w-1/2 w-full">
                  <label class="font-semibold">{{$t('adminUser.phoneNumber')}}</label>
                  <vs-input class="w-full"
                    v-validate="'numeric|min:10|max:11'"
                    data-vv-validate-on="blur"
                    type="text"
                    name="phoneNumber"
                    v-model="user.phoneNumber"
                    autocomplete="off"
                    />
                  <span class="text-danger text-sm">{{
                      errors.first("phoneNumber")
                    }}</span>
                </div>
              </div>
              <hr class="mt-8 mb-6 opacity-25">
              <div class="btn_save">
                <vs-button @click="saveChanges" :disabled="!validateForm" style="width: 150px;">{{$t('adminFbIcon.saveData')}}</vs-button>
              </div>
            </div>
          </div>
        </div>
      </div>
  </div>
</div>
  
</template>

<script>
import vSelect from 'vue-select'
export default {
  components:{
    vSelect
  },
  name: "OrganizationInformation",
  data(){
    return {
      jobSelect:null,
      id: null,
      user:{
        organizationName:null,
        fullAddressModel:null,
        email:null,
        phoneNumber:null
      },
      optionalJobs:[
        {label:this.$t('optionalJob.all'),value:0},
        {label:this.$t('optionalJob.realEstate'),value:1},
        {label:this.$t('optionalJob.iT'),value:2},
        {label:this.$t('optionalJob.insurance'),value:3},
        {label:this.$t('optionalJob.freightForwarders'),value:4},
        {label:this.$t('optionalJob.pGovernmentService'),value:5},
        {label:this.$t('optionalJob.ecommerce'),value:6},
        {label:this.$t('optionalJob.pMedical'),value:7},
        {label:this.$t('optionalJob.construct'),value:8},
        {label:this.$t('optionalJob.fBanking'),value:9},
        {label:this.$t('optionalJob.fBeverages'),value:10},
        {label:this.$t('optionalJob.entertain'),value:11},
        {label:this.$t('optionalJob.fConsumption'),value:12},
        {label:this.$t('optionalJob.mAdvertisement'),value:13},
        {label:this.$t('optionalJob.agriculture'),value:14},
        {label:this.$t('optionalJob.fintech'),value:15},
        {label:this.$t('optionalJob.rCommercial'),value:16},
        {label:this.$t('optionalJob.lLegal'),value:17},
        {label:this.$t('optionalJob.bCHealth'),value:18},
        {label:this.$t('optionalJob.hMotels'),value:19},
        {label:this.$t('optionalJob.energy'),value:20},
        {label:this.$t('optionalJob.travel'),value:21},
        {label:this.$t('optionalJob.education'),value:22}
      ],
    }
  },
  computed: {
    validateForm() {
      return !this.errors.any();
    },
    genderModel: {
      get() {
        let obj = this.genderOptions.find(x => x.value === this.user.gender);
        if (!obj) {
          return null;
        }
        return {
          label: obj.label,
          value: this.user.gender
        }
      },
      set(obj) {
        this.user.gender = obj.value;
      }
    },
    activeStatusModel: {
      get() {
        let obj = this.activeStatusOptions.find(x => x.value === this.user.activeStatus);
        if (!obj) {
          return null;
        }
        return {
          label: obj.label,
          value: this.user.activeStatus
        }
      },
      set(obj) {
        this.user.activeStatus = obj.value;
      }
    },
    province: {
      get() {
        let obj = this.cityOptions.find(x => x.value === this.user.city);
        if (!obj) {
          return null;
        }
        return {
          label: obj.label,
          value: this.user.city
        }
      },
      set(obj) {
        this.user.city = obj.value;
        this.districtOptions = this.province.getDistrict(obj.value);
        this.user.district = this.districtOptions[0].value;
        this.subDistrictOptions = this.province.getSubDistrict(this.user.city, this.user.district);
        this.user.subDistrict = this.subDistrictOptions[0].value;
      }
    },
    district: {
      get() {
        let obj = this.districtOptions.find(x => x.value === this.user.district);
        if (!obj) {
          return null;
        }
        return {
          label: obj.label,
          value: this.user.district
        }
      },
      set(obj) {
        this.user.district = obj.value;
        this.subDistrictOptions = province.getSubDistrict(this.user.city, obj.value);
        this.user.subDistrict = this.subDistrictOptions[0].value;
      }
    },
    subDistrict: {
      get() {
        let obj = this.subDistrictOptions.find(x => x.value === this.user.subDistrict);
        if (!obj) {
          return null;
        }
        return {
          label: obj.label,
          value: this.user.subDistrict
        }
      },
      set(obj) {
        this.user.subDistrict = obj.value
      }
    },
  },
  created() {
    this.$oauth.get('/user/current').then((response) => {
      this.user = Object.assign({}, this.user, response.data);
      this.jobSelect = this.optionalJobs[0];
      this.user.organizationName = this.user.organization ? this.user.organization.organizationName : "";
    })
  },
  methods: {
    getLabelString(object) {
      return (object && object.label);
    },
    getRole(role) {
      switch (role) {
        case 'ROLE_ADMIN': return 'admin';
        case 'ROLE_ADMIN_ORGANIZATION': return 'organization';
        case 'ROLE_CONTRIBUTOR': return 'contributor';
        default: return 'user';
      }
    },
    changeGender () {
      this.$validator.validateAll()
    },
    async saveChanges(evt) {
      evt.preventDefault();
      if (!this.validateForm) return;

      const result = await this.$validator.validateAll();
      if (!result) return;
      let path = '/business-user/update-info';
      let userRequest = {
        email: this.user.email,
        phoneNumber: this.user.phoneNumber,
        organizationName: this.user.organizationName,
      };
      this.$vs.loading();
      this.$business.post(path, userRequest).then((response) => {
        this.$vs.loading.close();
        this.$vs.notify({
          color: 'primary',
          text: 'Cập nhật tài khoản thành công',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
        });
        this.$oauth.get('/user/current').then((response) => {
          this.user = Object.assign({}, this.user, response.data);
          this.user.organizationName = this.user.organization ? this.user.organization.organizationName : "";
        })
      }).catch((err) => {
        this.$vs.loading.close();
        return this.$vs.notify({
          text: err.response.data.message || err.response.data.error_description || err.response.data.error,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger'
        });
      });
    },
  }
}
</script>

<style scoped>
.title_card{
  font-weight: bold;
  font-size: 28px;
  margin-left: -1rem;
}
.btn_save{
  display: flex;
  justify-content: flex-end;
  margin-top: 20px;
  padding-right: 10px;

}
</style>
